import React, { FC, useState } from 'react'

import dayjs from 'dayjs'

import { CalendarHeader, CalendarWeekday, RangeCalendarDays } from 'src/components/molecules'

type Props = {
  startDate?: Date
  endDate?: Date
  onClickDay: (input: { startDate: Date; endDate?: Date }) => void
  className?: string
}

export const RangeCalendar: FC<Props> = ({ startDate, endDate, onClickDay, className }) => {
  const [targetDate, setTargetDate] = useState(startDate ?? new Date())

  const disabledAfterDate = dayjs().add(1, 'day').hour(0).minute(0).second(0).toDate()

  return (
    <div className={className}>
      <CalendarHeader
        targetDate={targetDate}
        onClickNext={() => setTargetDate(dayjs(targetDate).add(1, 'month').toDate())}
        onClickPrev={() => setTargetDate(dayjs(targetDate).subtract(1, 'month').toDate())}
        disabledAfterDate={disabledAfterDate}
        className="tw-mx-s2 tw-mt-s2"
      />
      <CalendarWeekday className="tw-mt-s-2" />
      <RangeCalendarDays
        startDate={startDate}
        endDate={endDate}
        targetDate={targetDate}
        onClickDay={onClickDay}
        disabledAfterDate={disabledAfterDate}
        className="tw-mt-s0"
      />
    </div>
  )
}
